/* esm.sh - @radix-ui/react-context@1.1.3 */
export * from "/*@radix-ui/react-context@1.1.3/esnext/react-context.mjs";
